<template>
    <div v-show='isActive' class="mt-5">
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        title: String
    },
    data() {
        return {
            isActive: true
        };
    }
};
</script>
